import type { PageContext } from 'vike/types';
import { getSiteName } from 'src/utils/ssrMeta';
import type { PageData } from './+data';

// Vike requires functional config values that read pageContext to live
// in their own +<name>.ts files (so the build pipeline can codegen the
// per-environment serialization).
//
// vike-react renders this as both <title> and <meta property="og:title">.
// vike-react does NOT fall back to the global pages/+config.ts title
// when this returns undefined — a per-route +title.ts entirely takes
// over. So we explicitly compute a site-aware default for both the
// happy path (org loaded) and the fallback (org fetch failed).
export default (pageContext: PageContext): string => {
   const siteName = getSiteName(pageContext);
   const { organization } = (pageContext.data ?? {}) as PageData;
   const orgName =
      organization?.beneficiary?.trim() ||
      organization?.nickname?.trim() ||
      organization?.name?.trim();
   return orgName
      ? `${orgName} on ${siteName} - Book hotels at the same prices to support ${orgName}`
      : `${siteName} — Book hotels at the same prices and support your program`;
};
